import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import {
  AdviceSettings,
  CompanySettings,
  Monitor,
  MonitorType,
} from '../models/mowing-monitor.model';
import { UploadFileResult } from './../models/mowing-monitor.model';

@Injectable({
  providedIn: 'root',
})
export class DairyAdviceService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/dairy-advice/secure';

  constructor() {}

  getMonitorItems(monitorType: MonitorType): Observable<Monitor> {
    return this.http.get<Monitor>(`${this.baseUrl}/monitor?type=${monitorType}`);
  }

  getCompanySettings(): Observable<CompanySettings> {
    return this.http.get<CompanySettings>(`${this.baseUrl}/customer-settings`);
  }

  postCompanySettings(companySettings: CompanySettings) {
    return this.http.post<CompanySettings>(`${this.baseUrl}/customer-settings`, companySettings);
  }

  getAdviceSettings(): Observable<AdviceSettings> {
    return this.http.get<AdviceSettings>(`${this.baseUrl}/advice-settings`);
  }

  postAdviceSettings(adviceSettings: AdviceSettings) {
    return this.http.post<AdviceSettings>(`${this.baseUrl}/advice-settings`, adviceSettings);
  }

  uploadMonitorItems(file: File): Observable<UploadFileResult> {
    const formData = new FormData();
    formData.append('File', file);
    return this.http.post(`${this.baseUrl}/monitor`, formData).pipe(
      map((_) => ({ success: true }) as UploadFileResult),
      catchError((err) => of(err.error as UploadFileResult)),
    );
  }

  uploadNotifications(file: File): Observable<UploadFileResult> {
    const formData = new FormData();
    formData.append('File', file);
    return this.http.post(`${this.baseUrl}/notifications`, formData).pipe(
      map((_) => ({ success: true }) as UploadFileResult),
      catchError((err) => of(err.error as UploadFileResult)),
    );
  }
}
